import Vue                      from "vue";
import { IFullPartDetailWithReplacementItemsDto } from "@/types/FullPartDetailWithReplacementItems";
import { mapGetters }           from "vuex";
import { 
  formatDateTime, 
  stringHelper,
  sizeHelper,
  partInfoHelper
}                               from "@/components/mixins";
import { 
  LoadingSpinner,
  DnFunctionButton 
}       from "@/components/Elements"
import CurrencyText             from "@/components/Elements/CurrencyText.vue";
import DnNumberInput            from "@/components/Elements/DnNumberInput.vue"
import PartRequestQuote         from "@/components/PartRequestQuote/PartRequestQuote.vue"
import ReplacementItems         from "@/components/Elements/ReplacementItems/ReplacementItems.vue"
import vSelect                  from "vue-select"
import SkeletonLoader from "@/components/Elements/SkeletonLoader.vue";

// icons
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import { faChevronDown, faChevronUp } from "@fortawesome/free-solid-svg-icons";


export default Vue.extend({
  name: "PartInfo",
  components: {
    FontAwesomeIcon,
    vSelect,
    LoadingSpinner,
    CurrencyText,
    DnNumberInput,
    DnFunctionButton,
    PartRequestQuote,
    ReplacementItems,
    SkeletonLoader
  },
  mixins: [formatDateTime, stringHelper, sizeHelper,partInfoHelper], 
   computed: {
      ...mapGetters([
        "collapseAllPartDescriptionsValue",
      ]),
    }, 
  data: () => ({
    downChevronIcon: faChevronDown,
    upChevronIcon: faChevronUp,
    replacementItems: [] as IFullPartDetailWithReplacementItemsDto[],
    replacementItemsLoading: false,
  }),
  watch: {
    collapseAllPartDescriptionsValue(newValue) {
      this.collapsePartDescription = newValue;
    },
    isSuperseded: {
      immediate: true,
      handler(val) {
        if (val) {
          this.getSuperSessions();
        }
      },
    },
  },
  created() {
    this.collapsePartDescription = this.collapseAllPartDescriptionsValue;
  },
  methods: {

  swapIcon() {
    if (this.collapsePartDescription) {
      this.collapsePartDescription = false;
      this.icon = "upChevronIcon";
    } else {
      this.collapsePartDescription = true;
      this.icon = "downChevronIcon";
    }
  },

    async getSuperSessions() {
      if (this.isSuperseded) {
        this.replacementItemsLoading = true;
        try {
          this.replacementItems = await this.getReplacementItems();
        } finally {
          this.replacementItemsLoading = false;
        }
      }
    },
  },
});
